module.exports = "/static/js/2b62bf7f0f498630dbd9fff6830da655.png";